import { render, staticRenderFns } from "./message_view.vue?vue&type=template&id=75457f9c&scoped=true&"
import script from "./message_view.vue?vue&type=script&lang=js&"
export * from "./message_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75457f9c",
  null
  
)

export default component.exports